import { render } from "./WindowElevator.vue?vue&type=template&id=79c71402"
import script from "./WindowElevator.vue?vue&type=script&lang=js"
export * from "./WindowElevator.vue?vue&type=script&lang=js"

import "./WindowElevator.vue?vue&type=style&index=0&id=79c71402&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__